import { faMemo } from '@fortawesome/pro-solid-svg-icons';

import { Tag } from '@growtherapy/sprout-ui';

import { IconMenuItem } from '../../components';
import { PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';

export function ClientInformationDrawerControlMenuItem({
  isClientInfoDrawerOpen,
  hasNewClientInfo,
  onClick,
}: {
  isClientInfoDrawerOpen: boolean;
  hasNewClientInfo?: boolean;
  onClick: () => void;
}) {
  return (
    <IconMenuItem
      aria-controls={PUSH_DRAWER_ARIA_CONTROLS_ID}
      aria-expanded={isClientInfoDrawerOpen}
      onClick={onClick}
      icon={faMemo}
    >
      <span className='sr-only'>{isClientInfoDrawerOpen ? 'Close' : 'Open'} client information</span>
      <span aria-hidden>Client info</span>
      {hasNewClientInfo && (
        <Tag aria-label='new info available' use='lilac'>
          New
        </Tag>
      )}
    </IconMenuItem>
  );
}
